import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { LOGOUT } from 'ConstComponents';
import { Insert as OPERATOR_WISE_VIEW_PROVIDER } from 'Components/Api/OperatorWiseViewProviderApi';
import { SelectForViewAPIDropDown as PROVIDER_VIEW_DROP_DOWN } from 'Components/Api/ProviderApi';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

import {
    Container,
    Grid,
    Button,
    CircularProgress,
    Hidden
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const Add = ({
           OperatorID,
           ServiceID,
           OperatorName,
           setIsModalOpen,
           selectUserID,
           onDismissCallback
       }) => {
           const classes = commonStyle();

           const [responseMessage, setResponseMessage] = useState('');
           const [isError, setIsError] = useState(false);
           const [loading, setLoading] = useState(false);
           const [severity, setSeverity] = useState('success');

           const [viewProviderList, setViewProviderList] = useState([]);

           const initialFormValues = {
               OperatorID: OperatorID,
               OperatorName: OperatorName,
               ServiceID: ServiceID,
               ViewProviderList: []
           };

           useEffect(() => {
               selectFilteredProvider();
           }, []);

           const selectFilteredProvider = async () => {
               const response = await PROVIDER_VIEW_DROP_DOWN();
               setLoading(false);
               if (!response.isAuthorized) {
                   LOGOUT();
               }
               if (!response.status) {
                   return;
               }
               var data = JSON.parse(response.data);
               setViewProviderList(data);
           };

           const submithandle = async (
               values,
               { setSubmitting, resetForm }
           ) => {
               if (loading) {
                   setLoading(false);
                   return;
               }

               var requestObj = JSON.stringify(values);
               setLoading(true);
               setIsError(false);
               setSubmitting(false);
               var response = await OPERATOR_WISE_VIEW_PROVIDER(requestObj);

               if (!response.isAuthorized) {
                   LOGOUT();
               }

               setIsError(true);
               setSubmitting(true);

               setSeverity('success');
               setResponseMessage(response.data);

               if (!response.status) {
                   setSeverity('error');
                   return;
               }

               setTimeout(() => {
                   onDismissCallback(selectUserID);
                   setIsModalOpen(false);
               }, MESSAGE_CLOSE_AFTER);
           };

           return (
               <CustomContainer
                   isLoading={loading}
                   isError={isError}
                   alertMessage={responseMessage}
                   severity={severity}
                   onCloseCallback={(alertState) => {
                       setIsError(alertState);
                   }}
               >
                   <Formik
                       enableReinitialize={true}
                       initialValues={initialFormValues}
                       onSubmit={submithandle}
                       //resetForm={formObject}
                   >
                       {(formProps) => {
                           return (
                               <Form>
                                   <Grid item xs={12}>
                                       <Grid container spacing={2}>
                                           <Grid
                                               item
                                               xs={12}
                                               sm={12}
                                               md={6}
                                               lg={6}
                                           >
                                               <MaterialTextField
                                                   label="Operator Name"
                                                   name="OperatorName"
                                                   type="text"
                                                   readOnly={true}
                                                   placeholder="Operator Name"
                                               />

                                               <Hidden xsUp>
                                                   <MaterialTextField
                                                       label="OperatorID"
                                                       name="OperatorID"
                                                       type="text"
                                                       readOnly={true}
                                                       placeholder="OperatorID"
                                                   />
                                               </Hidden>
                                           </Grid>
                                           <Grid
                                               item
                                               xs={12}
                                               sm={12}
                                               md={12}
                                               className={classes.multiSelect}
                                           >
                                               <Autocomplete
                                                   multiple
                                                   name="ViewProviderList"
                                                   options={viewProviderList}
                                                   value={
                                                       formProps.values
                                                           .ViewProviderList
                                                   }
                                                   getOptionLabel={(option) =>
                                                       option.ProviderName
                                                   }
                                                   getOptionSelected={(
                                                       option,
                                                       value
                                                   ) =>
                                                       option.ProviderID ===
                                                       value.ProviderID
                                                   }
                                                   onChange={(
                                                       event,
                                                       values
                                                   ) => {
                                                       formProps.setFieldValue(
                                                           'ViewProviderList',
                                                           values.map(
                                                               (category) => ({
                                                                   ProviderID:
                                                                       category.ProviderID,
                                                                   ProviderName:
                                                                       category.ProviderName
                                                               })
                                                           )
                                                       );
                                                   }}
                                                   renderInput={(params) => (
                                                       <TextField
                                                           {...params}
                                                           variant="outlined"
                                                           label="View Provider(s)"
                                                           placeholder="Select Providers"
                                                       />
                                                   )}
                                               />
                                           </Grid>
                                       </Grid>
                                   </Grid>

                                   <Grid className={classes.footerGrid}>
                                       <Box className={classes.flexReverse}>
                                           <div
                                               className={classes.SubmitWrapper}
                                           >
                                               <Button
                                                   type="submit"
                                                   title="Save"
                                                   className={
                                                       classes.CustomPrimaryButtonStyle
                                                   }
                                                   disabled={loading}
                                               >
                                                   Save
                                               </Button>
                                               {loading && (
                                                   <CircularProgress
                                                       size={24}
                                                       className={
                                                           classes.buttonProgress
                                                       }
                                                   />
                                               )}
                                           </div>
                                       </Box>
                                   </Grid>
                               </Form>
                           );
                       }}
                   </Formik>
               </CustomContainer>
           );
       };
